import { Lista } from "@/models/gessan/lista";

interface HeaderItemTableSaneamento {
  text: String;
  align: String;
  sortable: Boolean;
  value: String;
  width?: String;
}

export interface PaginationTableSaneamento {
  mesAno?: string;
  qtdeUnAbastecimentoAgua?: string | number | null;
  qtdeUnEsgotamentoSanitario?: string | number | null;
  faturamentoMensalLiquido?: string | number | null;
  municipio?: String;
  situacao?: [];
  situacaoDae?: string;
  page: number;
  size: number;
  totalElements?: number;
  cnpj?: string;
  sortBy?: string;
  sortOrder?: string;
}

export interface TableSaneamento {
  header: HeaderItemTableSaneamento[];
  content: Lista[];
  paginate: PaginationTableSaneamento;
  isLoading: Boolean;
  total: Number;
}

const header: HeaderItemTableSaneamento[] = [
  {
    text: "Mês/Ano",
    align: "start",
    sortable: true,
    value: "mesAno",
  },
  {
    text: "Município",
    align: "start",
    sortable: true,
    value: "municipio",
  },
  {
    text: "Quantidade de Ligações Ativas de Água",
    align: "start",
    sortable: true,
    value: "qtdeUnAbastecimentoAgua",
  },
  {
    text: "Quantidade de Ligações Ativas de Esgoto",
    align: "start",
    sortable: true,
    value: "qtdeUnEsgotamentoSanitario",
  },
  {
    text: "Faturamento Direto Mensal Líquido",
    align: "start",
    sortable: true,
    value: "faturamentoMensalLiquido",
  },
  {
    text: "Situação",
    align: "start",
    sortable: true,
    value: "situacao",
  },
  
  {
    text: "DAE",
    align: "start",
    sortable: true,
    value: "situacaoDae",
  },
  {
    text: "Ações",
    align: "start",
    sortable: false,
    value: "acoes",
  },
];

const content: Lista[] = [];

const paginate: PaginationTableSaneamento = {
  mesAno: null,
  qtdeUnAbastecimentoAgua: null,
  qtdeUnEsgotamentoSanitario: null,
  faturamentoMensalLiquido: null,
  situacao: null,
  situacaoDae: null,
  municipio: null,
  page: 0,
  size: 10,
  totalElements: null,
  cnpj: null,
};

const tableState: TableSaneamento = {
  header,
  content,
  paginate,
  isLoading: false,
  total: 0,
};

export { tableState };
